import { useQueryClient } from 'react-query';
import { useCallback } from 'react';
import { CacheKeys } from '../constants';
import { MatchStatus, UserType } from '../types';
import { useProfileContext } from './useProfileContext';
export const useLocalMatchCreation = () => {
    const queryClient = useQueryClient();
    const { profile } = useProfileContext();
    const mutate = useCallback((data) => {
        if ((profile === null || profile === void 0 ? void 0 : profile.type) === UserType.TUTOR &&
            data.status === MatchStatus.Pending) {
            queryClient.setQueryData([CacheKeys.PENDING_MATCHES], (prev) => {
                if (!prev)
                    return [data];
                const match = prev.find((m) => m.id === data.id);
                if (match)
                    return prev.map((m) => (m.id === data.id ? data : m));
                return [data, ...prev];
            });
        }
        else {
            queryClient.setQueryData([CacheKeys.MATCHES], (prev) => {
                if (!prev)
                    return undefined;
                return Object.assign(Object.assign({}, prev), { pages: prev.pages.map((page, i) => {
                        if (i !== 0)
                            return page;
                        return {
                            records: [data, ...page.records],
                            meta: page.meta
                        };
                    }) });
            });
        }
        queryClient.setQueryData([CacheKeys.MATCH, data.id], () => data);
    }, [profile]);
    return { mutate };
};
//# sourceMappingURL=useLocalMatchCreation.js.map